import { useTranslation } from "react-i18next";
import { useApiQuery } from "../../services/api";
import { getRoomColors } from "../../domains/room/utils/getRoomColors";
import {
  RoomOrganizationKey,
  useRoomOrganizationKey,
} from "../../domains/room/hooks/useRoomOrganizationKey";
import { PartnershipBanner } from "../ui/PartnershipBanner";

export default function RoomDisclaimerBanner({
  roomId,
}: {
  roomId: string | null;
}) {
  const { t } = useTranslation();
  const roomQuery = useApiQuery(
    "/webapp/private/rooms/:id",
    roomId !== null ? { param: { id: roomId } } : false
  );
  const { roomBackgroundColor } = getRoomColors(
    roomQuery.state === "success" ? roomQuery.body.primaryColor : null
  );
  const disclaimerByOrg = {
    none: null,
    pierreFabre: null,
    takeda: t("Produced with the institutional support of Takeda France."),
    vifor: t("Produced with the institutional support of CSL France."),
    chiesi: t("Produced with the institutional support of Chiesi"),
  } satisfies Record<RoomOrganizationKey, string | null>;
  const disclaimer = disclaimerByOrg[useRoomOrganizationKey(roomId)];

  if (disclaimer === null) return null;

  return (
    <PartnershipBanner
      backgroundColor={
        roomBackgroundColor === undefined ? null : roomBackgroundColor
      }
      textColor={null}
      className="sticky top-0 z-9"
    >
      {disclaimer}
    </PartnershipBanner>
  );
}
